"use client";
import { ConfigProvider } from "antd";
import Header from "@/components/layouts/Header";
import { useState } from "react";
import { MainContext } from "@/contexts/MainContext";
import { usePathname, useRouter } from "next/navigation";
import Footer from "@/components/layouts/Footer";
import useScreenType from "@/services/useScreenType";
import useRefreshScrollRestoration from "@/hooks/useRefreshScrollRestoration";
import AOS from "aos";
import { useEffect } from "react";
function IndexLayout({ children, setting, services }) {
  const router = useRouter();
  const aboutUs = JSON.parse(setting?.aboutUs || "{}");

  useEffect(() => {
    AOS.init({
      offset: 400,
      duration: 1000,
      achorPlacement: "top ",
    });
  }, []);

  useRefreshScrollRestoration();
  const pathname = usePathname();
  const [pinnedCategory, setPinnedCategory] = useState(undefined);
  const isSmallScreen = useScreenType();
  const screenHeight = typeof window !== "undefined" ? window.innerHeight : 0;

  let timeoutId = null;

  const menuItems = [
    {
      label: "Trang chủ",
      slug: "/",
    },
    {
      label: "Về chúng tôi",
      slug: "/ve-chung-toi",
    },
    {
      label: "Dịch vụ",
      slug: "/dich-vu",
    },
    {
      label: "Tuyển dụng",
      slug: "/tuyen-dung",
    },
    {
      label: "Tin tức",
      slug: "/tin-tuc",
    },
    {
      label: "Dự án",
      slug: "/du-an",
    },
    {
      label: "Liên hệ",
      slug: "/lien-he",
    },
  ];

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#E5C383",
          controlItemBgActiveHover: "#fff",
          fontFamily: "var(--font-inter)",
        },
        components: {},
      }}
    >
      <div className="min-h-[100vh] overflow-x-hidden relative">
        <div className="mx-auto min-h-screen flex flex-col">
          <MainContext.Provider value={{}}>
            <div className={`fixed-menu bg-[#0C1B56]`}>
              <Header aboutUs={aboutUs} menuItems={menuItems} />
            </div>
            <div className="flex-grow md:mt-[90px] mt-0 min-h-screen  bg-white">
              {children}
            </div>
            <Footer
              aboutUs={aboutUs}
              menuItems={menuItems}
              services={services}
            />
          </MainContext.Provider>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default IndexLayout;
